import { render, staticRenderFns } from "./TypicalStyle.vue?vue&type=template&id=da1a805c&scoped=true"
import script from "./TypicalStyle.vue?vue&type=script&lang=js"
export * from "./TypicalStyle.vue?vue&type=script&lang=js"
import style0 from "./TypicalStyle.vue?vue&type=style&index=0&id=da1a805c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1a805c",
  null
  
)

export default component.exports